import { Order, SystemConfig } from '../../../../types';
import { ClusterReadiness, DivergentThresholds } from './types';

export const getClusterReadiness = (cluster: Order[]): ClusterReadiness => ({
    anyNotReady: cluster.some((order) => !order.isReady && order.status !== 'ready'),
    allReady: cluster.every((order) => order.isReady || order.status === 'ready')
});

export const getDivergentThresholds = (config: SystemConfig): DivergentThresholds => ({
    boomerangSlackThreshold: Math.max(6, config.fleetConfig.slaToleranceMinutes || 10),
    dispatchHoldThreshold: Math.max(4, Math.floor((config.fleetConfig.slaToleranceMinutes || 10) / 2))
});

export const getOldestElapsedMinutes = (cluster: Order[]): number => {
    return Math.max(
        ...cluster.map((order) => {
            const refNow = Date.now();
            return (refNow - (order.createdAt || refNow)) / 60000;
        })
    );
};

export const isHoldAllowedByGuardrail = (
    oldestElapsedMinutes: number,
    clusterSize: number,
    maxHoldMinutes: number,
    maxHoldOrders: number
): boolean => oldestElapsedMinutes <= maxHoldMinutes && clusterSize <= maxHoldOrders;

export const isStrategyIgnored = (cluster: Order[], strategy: string): boolean => {
    return cluster.some((order) => order.ignoredStrategies?.includes(strategy));
};
